<template>
  <q-layout view="Hhh lpr fff">
    <q-layout-header>
      <q-toolbar>
        <q-btn
          flat
          dense
          @click="back"
          icon="chevron_left"
          :label="$t('nav.quotes')"
        />
        <q-btn
          v-if="changed"
          flat
          dense
          @click="save"
          class="q-ml-auto"
          :label="$t('general.save')"
        />
      </q-toolbar>
      <q-toolbar inverted class="justify-between">
        <q-btn :label="$t('quote_detail.start')" color="primary" class="thirds" @click="updateStatus(status.started)"></q-btn>
        <q-btn :label="$t('quote_detail.completed')" color="primary" class="thirds" @click="updateStatus(status.completed)"></q-btn>
        <q-btn :label="$t('quote_list.in_progress')" color="primary" class="thirds" @click="updateStatus(status.inProgress)"></q-btn>
      </q-toolbar>
    </q-layout-header>
    <q-page-container>
      <q-page padding>
        <q-field
          v-for="(f, fldName) in fields"
          :label="f.label"
          :key="fldName"
          class="q-mb-md q-pb-md"
          style="border-bottom: 1px solid #ccc"
        >
          <div v-if="['date', 'time', 'datetime'].indexOf(f.dataType) !== -1">
            {{ formatTime(quote.attributes[fldName], f.dataType) }}
          </div>
          <div v-else-if="['picklist', 'picklist.multiple'].indexOf(f.type) !== -1">
            {{ picklistValue(f.picklist_id, quote.attributes[fldName])}}
          </div>
          <div v-else-if="fldName === 'cf_tyon_suorittaja'">
            {{ userFullName(quote.attributes[fldName]) }}
          </div>
          <div v-else-if="['cf_1572', 'cf_1574'].indexOf(fldName) !== -1">
            <a :href="`tel:${quote.attributes[fldName]}`">{{ quote.attributes[fldName] }}</a>
          </div>
          <q-input
            v-else-if="fldName === 'cf_1545'"
            v-model="quote.attributes[fldName]"
            @input="changed = true"
            type="textarea"
            hide-underline
          />
          <div v-else>
            {{ quote.attributes[fldName] }}
          </div>
        </q-field>
        <q-table
          :data="rowData"
          :columns="rowColumns"
          :rows-per-page-options="[0]"
          :pagination.sync="pagination"
          hide-bottom
          class="q-mt-lg"
        />
      </q-page>
    </q-page-container>

    <q-dialog
      v-model="userModal"
      :title="$t('quote_detail.assign_to_user')"
      ok="OK"
      :cancel="$t('general.cancel')"
      @cancel="tempUser = null"
      @ok="assignUser"
      @show="tempUser = quote.attributes.cf_tyon_suorittaja"
    >
      <div slot="body">
        <q-field>
          <q-select
            v-model="tempUser"
            :options="users"
            filter
          />
        </q-field>
      </div>
    </q-dialog>
  </q-layout>
</template>
<script>
import config from 'config'
import { date } from 'quasar'
import crmService from '@/services/crm_service'

export default {
  data () {
    return {
      status: config.quotes.status,
      userModal: false,
      tempUser: null,
      changed: false,
      rowColumns: [
        {
          name: 'qty',
          label: this.$t('quote_detail.quantity'),
          field: 'quantity',
          align: 'right'
        },
        {
          name: 'name',
          label: this.$t('quote_detail.product'),
          field: 'productName',
          align: 'left'
        }
      ],
      pagination: {
        page: 1,
        rowsPerPage: 0
      }
    }
  },
  computed: {
    rowData () {
      return this.rows.map(row => {
        return {
          quantity: Math.round(row.attributes.quantity),
          productName: this.productName(row)
        }
      })
    },
    quote () {
      return this.$store.getters.quote(this.$route.params.id)
    },
    rows () {
      const rowIds = this.quote.relationships.rows.data.map(obj => obj.id)
      return this.$store.state.quotes.quotes.included.filter(obj => obj.type === 'quote_rows' && rowIds.includes(obj.id))
    },
    productIds () {
      if (!this.rows.length) return
      return this.rows.map(obj => obj.relationships.product.data.id)
    },
    products () {
      return this.$store.state.products.products.data.filter(obj => this.productIds.includes(obj.id))
    },
    schema () {
      return this.$store.state.schema.schema.quotes.attributes
    },
    fields () {
      const schema = this.schema
      const result = {}
      config.quotes.fields.forEach(fld => {
        if (schema[fld]) result[fld] = schema[fld]
      })
      return result
    },
    users () {
      return this.$store.state.users.users.data.map(user => {
        return { label: `${user.attributes.first_name} ${user.attributes.last_name}`, value: parseInt(user.id) }
      })
    }
  },
  watch: {
    productIds (ids) {
      this.$store.dispatch('getProducts', ids)
    },
    fields (flds) {
      Object.values(flds)
        .map(fld => fld.picklist_id)
        .filter(item => item !== null)
        .forEach(id => this.$store.dispatch('getPicklistValues',
          { id: id, locale: this.$i18n.locale }))
    }
  },
  methods: {
    userFullName (userId) {
      if (!userId) return ''
      const user = this.$store.getters.user(userId.toString())
      if (!user) return 'N/A'
      return `${user.attributes.first_name} ${user.attributes.last_name}`
    },
    picklistValue (picklistId, val) {
      const values = this.$store.getters.picklistValues(picklistId, this.$i18n.locale)
      const value = values.find(v => v.value === val)
      return value && value.label
    },
    dateFormat (dataType) {
      switch (dataType) {
        case 'date':
          return 'DD.MM.YYYY'
        case 'time':
          return 'HH:MM'
        case 'datetime':
          return 'DD.MM.YYYY HH:mm'
        default:
          return 'DD.MM.YYYY HH:mm'
      }
    },
    formatTime (val, dataType) {
      return val && date.formatDate(val, this.dateFormat(dataType))
    },
    productName (row) {
      const productId = row.relationships.product.data.id
      const product = this.products.find(obj => obj.id === productId)
      if (product && product.attributes.name) return product.attributes.name
      else return ''
    },
    back () {
      if (this.changed) {
        this.saveQuote()
      }
      this.$router.back()
    },
    save () {
      this.saveQuote(() => {
        this.$q.notify({
          message: this.$t('general.changes_saved'),
          position: 'bottom',
          type: 'positive',
          timeout: 2000
        })
      })
    },
    saveQuote (successCb = null) {
      const saveObj = Object.assign({}, this.quote)
      Object.keys(saveObj.attributes).forEach(key => {
        if (!Object.keys(this.fields).includes(key)) delete saveObj.attributes[key]
      })
      delete saveObj.relationships
      crmService.updateQuote(saveObj, (success, msg) => {
        if (success) {
          this.changed = false
          if (successCb) successCb()
        } else {
          this.$q.notify({
            message: this.$t('general.save_failed'),
            position: 'top'
          })
        }
      })
    },
    updateStatus (newStatus) {
      const userId = this.$store.state.auth.userId
      this.$store.dispatch('getUser', userId)
      this.quote.attributes.cf_tyon_suorittaja = userId
      this.quote.attributes.stage = newStatus
      this.saveQuote(() => {
        this.saveLocation(this.quote)
        this.$q.notify({
          message: this.$t(`quote_detail.status_message.${newStatus.replace(' ', '_')}`),
          position: 'bottom',
          type: 'positive',
          timeout: 2000
        })
      })
    },
    saveLocation (quote) {
      navigator.geolocation.getCurrentPosition(
        (pos) => this.updateLocation(quote, pos),
        (error) => this.positionErrorHiAcc(quote, error),
        { maximumAge: 0, timeout: 10000, enableHighAccuracy: true }
      )
    },
    positionErrorHiAcc (quote, error) {
      if (error.code === error.TIMEOUT) {
        // Try again with low accuracy
        navigator.geolocation.getCurrentPosition(
          (pos) => this.updateLocation(quote, pos),
          (error) => this.positionErrorLowAcc(quote, error),
          { maximumAge: 0, timeout: 10000, enableHighAccuracy: false }
        )
      } else {
        this.updateLocation(quote)
      }
    },
    positionErrorLowAcc (quote, error) {
      console.warn(`ERROR(${error.code}): ${error.message}`)
      this.updateLocation(quote)
    },
    updateLocation (quote, pos = null) {
      const saveObj = Object.assign({}, quote)
      delete saveObj.relationships
      saveObj.attributes = { cf_paikkatieto: this.locationStr(quote, pos) }
      crmService.updateQuote(saveObj)
    },
    locationStr (quote, pos = null) {
      const curDate = date.formatDate(new Date(), 'DD.MM.YYYY HH:mm')
      const stage = quote.attributes.stage
      const oldVal = quote.attributes.cf_paikkatieto
      const posStr = pos ? `LAT: ${pos.coords.latitude} / LONG: ${pos.coords.longitude}`
        : 'Paikkatieto ei saatavilla'
      const newVal = `(${curDate} / ${stage} / ${posStr})`
      if (oldVal) return `${oldVal}\n${newVal}`
      return newVal
    },
    assignUser () {
      this.quote.attributes.cf_tyon_suorittaja = this.tempUser
      const saveObj = Object.assign({}, this.quote)
      delete saveObj.relationships
      saveObj.attributes = { cf_tyon_suorittaja: this.tempUser }
      crmService.updateQuote(saveObj)
      this.tempUser = null
    }
  },
  mounted () {
    this.$store.dispatch('getQuote', this.$route.params.id)
    this.$store.dispatch('getSchema', { mod: 'quotes', locale: this.$i18n.locale })
    this.$store.dispatch('getUsers')
  },
  meta () {
    // Quasar meta plugin sets document title
    return {
      title: this.$t('nav.quotes')
    }
  }
}
</script>
<style>
.thirds {
  width: 32%;
}
</style>
